import styled from "styled-components";

const NavigationSection = styled.div`
    grid-area: navigation;
    margin-bottom: 1rem;
    overflow-y: scroll;
    overflow-x: hidden;
`;

export default NavigationSection;